<template>
  <div class="know-list">
    <div class="app-page-wrapper know-list-box">
      <div class="showLocationHint">
        <p class="hintContent">
          当前位置：<span @click="toHome" class="crumb-link">首页</span> >
          <span @click="backPrev" class="crumb-link">{{ column.name }}</span> > 
          <span class="crumb-text">资讯详情</span>
        </p>
      </div>
      <div class="showNewsInfo"
      >
        <p class="titleP">{{ title }}</p>
        <p class="timeP">{{ newsTime }}</p>
        <div class="showHtmlDiv" v-html="newsInfo"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { consultCategory } from '@/utils/global'
export default {
  data() {
    return {
      locationTitle: "",
      title: "",
      newsTime: "",
      newsInfo:'',
      catalogId: "",
      typeList: [
        {
          name: '权益保障',
          showUIViewType: true,
          label: 'rights'
        },
        {
          name: '法律资讯',
          showUIViewType: true,
          label: 'law'
        },
        {
          name: '民主管理',
          showUIViewType: true,
          label: 'democracy'
        },
        {
          name: '婚恋交友',
          showUIViewType: true,
          label: 'marriage'
        },
        {
          name: '基层动态',
          showUIViewType: true,
          label: 'bases'
        },
        {
          name: '普惠资讯',
          showUIViewType: true,
          label: 'inclusive'
        },
        {
          name: '有问有答',
          showUIViewType: true,
          label: 'dialog'
        }
      ]      
    };
  },
  computed: {
    column() {
      const { type, id } = this.$route.params
      return this.typeList.find(item => item.label === type) || {}
    }
  },
  created() {
    this.typeList.forEach(item => {
      const result = consultCategory.unit.find(child => child.name === item.name) || {}
      item.id = result.id || ''
    })
    this.setShowContent()
  },
  methods: {
    toHome() {
      this.$router.push('/home')
    },
    //详情界面点击返回上一个界面
    backPrev() {
      const type = this.column.label
      this.$router.push(`/column/${type}`)
    },
    async setShowContent() {
      const { code, data } = await this.$http.get_article_details({
        id: this.$route.params.id,
        catalogId: this.column.id,
        accessPassword: '',
        accessType: '',
        readFlag: 'no',
        tenantId: '',
      });
      if (code === 0) {
        this.title = data.title;
        this.newsTime = data.createdTime;
        // this.locationTitle = newData.tabInfo ? newData.tabInfo.title : "";
        this.newsInfo = data && data.content;
      }
    },
  },
};
</script>
<style lang='less' scoped>

.showNewsInfo {
  background: #ffffff;
  min-height: 600px;
  padding: 20px;
  // width: 100%;

  .titleP {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 30px;
    color: #333333;
    text-align: center;
    width: calc(100% - 40px);
    margin: 20px 20px 0px 20px;
  }

  .timeP {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-top: 15px;
    margin-bottom: 15px;
    text-align: center;
  }

  .showHtmlDiv{
    padding:  0 20px 10px 20px;
    line-height: 1.2;
  }
  ::v-deep img {
    max-width: 100%;
  }
}
</style>